import { render, staticRenderFns } from "./FoodAdd.vue?vue&type=template&id=0a0c531e&scoped=true&"
import script from "./FoodAdd.vue?vue&type=script&lang=js&"
export * from "./FoodAdd.vue?vue&type=script&lang=js&"
import style0 from "./FoodAdd.vue?vue&type=style&index=0&id=0a0c531e&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0c531e",
  null
  
)

export default component.exports